import React, { useState } from 'react'
import { Button, TextField, Container, Grid } from "@mui/material";
import adaptabilityIcon from '../assets/Navigation/nav_icon_adaptability_green.png'
import dataIcon from '../assets/Navigation/nav_icon_quality_green.png'
import costIcon from '../assets/Navigation/nav_icon_cost_green.png'
import expertiseIcon from '../assets/Navigation/nav_icon_expertise_green.png'
import Result from '../components/Result'
import {selectAdaptabilityQuestions} from '../features/adaptability/adaptabilitySlice'
import { selectDataQuestions } from '../features/data/dataSlice'
import {selectCostQuestions} from '../features/cost/costSlice'
import { selectExpertiseQuestions } from '../features/expertise/expertiseSlice'
import { useSelector } from 'react-redux'
import Oops from '../components/Oops'
import { jsPDF } from "jspdf";
import chart1 from "../assets/results/results_1st.jpg";
import chart2 from "../assets/results/results_2nd.jpg";
import chart3 from "../assets/results/results_3rd.jpg";
import chart4 from "../assets/results/results_4th.jpg";

import { ArrowForwardIos } from '@mui/icons-material'

const Results = () => {
    const adaptabilityQuestions = useSelector(selectAdaptabilityQuestions)
    const dataQuestions = useSelector(selectDataQuestions)
    const costQuestions = useSelector(selectCostQuestions)
    const expertiseQuestions = useSelector(selectExpertiseQuestions)

    const [name, setName] = useState('')
    const [companyName, setCompanyName] = useState('')
    const [phone, setPhone] = useState('')
    const [email, setEmail] = useState('')

    const handleNameChange = (event) => {
        setName(event.target.value);
      };
    const handleCompanyChange = (event) => {
        setCompanyName(event.target.value);
      };
    const handlePhoneChange = (event) => {
        setPhone(event.target.value);
      };
    const handleEmailChange = (event) => {
        setEmail(event.target.value);
      };

      let emailBody=`I have completed Emerson the Onshore Wellpad Optimization Tool and have downloaded a PDF of my results. I am interested in learning more about how Roxar 2600 Multiphase Flow Meter (MPFM) can improve my operations. Please have an Emerson expert contact me.\n\nContact information:\n${name}\n${companyName}\n${phone}\n${email}`

      emailBody = encodeURIComponent(emailBody)

    const calculateQuartile = (questions) => {
        const emptyQuestion = questions.find(question => question.answer === '')
        if (emptyQuestion){return 'incomplete'}
        var currentScore = 0
        var maxScore = 0
        for( var question of questions){
            currentScore += question.score
            maxScore += question.max
        }
        if(currentScore/maxScore > .75){
            return '1st'
        } else if (currentScore/maxScore > .5){
            return '2nd'
        } else if(currentScore/maxScore > .25) {
            return '3rd'
        } else {
            return '4th'
        }
    }
   

  const LEFT_MARGIN = 37;
  const INITIAL_Y = 85;
  const VERTICAL_SPACING = 30;
  const PDF_HEIGHT = 1123;
  const PDF_WIDTH = 794;
  const FONT_SIZE = 12;
  const TITLE_FONT_SIZE = 22;
  const FILL_COLOR = "#00358E";
  const LABEL_COLOR = "#1F598C";
  const VALUE_TEXT_COLOR = "#292929";

    const sections = [
        {
            title: 'Adaptability & Scalability',
            icon: adaptabilityIcon,
            statements: {
                '1st': 'Your operation looks to be optimized to respond to changes in production and scale with your operational goals or market conditions. You may have additional upside by focusing on how the Roxar 2600 can help  you in other areas such as better insight of your production, freeing up critical expertise, or optimizing cost. Check out those sections to learn more.',
                '2nd': `Congrats-you're doing better than more than half of your peers-but it looks like there is still room for improvement so you can scale your operation when the time comes, or quickly respond to changing market or operational conditions as they arise. We look forward to discussing further with you on how the Roxar 2600 Multiphase Flow Meter can help.`,
                '3rd': `You are on the road to an operation that is agile and scalable-but there may be more benefit for you in implementing a multiphase technology that helps you better scale and adapt. Our experts are ready to discuss ideas with you that can help you better respond to changing production performance, business goals or market direction.`,
                '4th': `It looks like the Roxar 2600 Multiphase Flow Meter could provide you significant upside to help you respond to changing well performance as well as quickly adapt to changing market conditions or business direction. We look forward to sharing some best practices to optimize your operation.`
            },
            quartile: calculateQuartile(adaptabilityQuestions),
            path: '/adaptability'
        },
        {
            title: 'Data Quality & Production Insight',
            icon: dataIcon,
            statements: {
                '1st': `You're likely getting the most out of what your well is telling you-identifying imminent issues, optimizing ongoing maintenance, and staying within the operating window of your wellsite equipment. Check out how the Roxar 2600 Multiphase Flow Meter can help you in other areas by visiting the sections on Adaptability & Scalability, Expertise Availability, and Cost Savings.`,
                '2nd': `Well done-you're in the top half of your peer group in understanding what your well is telling you. But there may be more to learn to identify imminent issues, optimize ongoing maintenance, and stay within the operating window of your wellsite equipment. We look forward to discussing further with you on how the Roxar 2600 Multiphase Flow Meter can help. `,
                '3rd': `It looks like you have a good handle on what is coming out of the ground at present-but there may be more benefit out there in identifying  imminent issues, optimizing ongoing maintenance, and staying within the operating window of your wellsite equipment. Our experts are ready to discuss ideas with you that can help you see further into the future with the insight a Roxar 2600 Multiphase Flow Meter can provide.  `,
                '4th': `It looks like the Roxar 2600 Multiphase Flow Meter could provide you significant insight that can help you see further into the future-identifying  imminent issues, optimizing ongoing maintenance, and staying within the operating window of your wellsite equipment. We look forward to sharing some best practices to optimize your operation.`
            },
            quartile: calculateQuartile(dataQuestions),
            path: '/data'
        },
        {
            title: 'Expertise Availability',
            icon: expertiseIcon,
            statements: {
                '1st': `You're likely getting the most out of your people, and have found the fine line between experience, availability, cost, and safety in terms of your personnel. Check out how the Roxar 2600 Multiphase Flow Meter can help you in other areas by visiting the sections on Adaptability & Scalability, Data Quality & Production Insight, and Cost Savings. `,
                '2nd': `Well done-you're above average in terms of putting your expertise to good use. But there may be a little more room to go to ensure availability, optimize technical expertise, and ensure a safe and reliable operation. We look forward to discussing further with you on how the Roxar 2600 Multiphase Flow Meter can help. `,
                '3rd': `It looks like you have a good handle on optimizing the use of your personnel and the insight they bring to your operation, but there may be more to benefit in terms of availability, growing workforce experience, and increasing safety performance all while   Our experts are ready to discuss with you how the Roxar 2600 Multiphase Flow Meter can help aid these improvements, as well as increase productivity and drive down costs.`,
                '4th': `There may be significant upside the Roxar 2600 Multiphase Flow Meter could bring in terms of increasing productivity and driving down personnel costs all while improving expertise availability, knowledge sharing, and safety performance. We look forward to sharing some best practices to optimize your operation.`
            },
            quartile: calculateQuartile(expertiseQuestions),
            path:'/expertise'
        },
        {
            title: 'Cost Savings',
            icon: costIcon,
            statements: {
                '1st': `It looks like you've found the fine line between CAPEX and OPEX, keeping costs low while staying prepared for the unexpected, and spending preventatively on maintenance to avoid larger costs of unplanned downtime. Check out how the Roxar 2600 Multiphase Flow Meter can help you in other areas by visiting the sections on Adaptability & Scalability, Data Quality & Production Insight, and Expertise Availability. `,
                '2nd': `Nice work-you're doing better than more than half of your peers. But it looks like there is still room for cost improvement-optimizing preventive vs remedial maintenance, reducing CAPEX investment, and avoiding costly (and often iterative) troubleshooting. We look forward to discussing further with you on how the Roxar 2600 Multiphase Flow Meter can help. `,
                '3rd': `You've started the journey on getting costs where they need to be-but it looks as though you could still benefit from optimizing preventive vs remedial maintenance, reducing CAPEX investment, and avoiding costly (and often iterative) troubleshooting. Our experts are ready to discuss ideas with you that can help you keep costs as low as they can be while still staying prepared for the unexpected.`,
                '4th': `It looks like the Roxar 2600 Multiphase Flow Meter could provide you significant cost savings-reducing CAPEX, keeping operating costs low, and avoiding unplanned events that can send your budget spiraling out of control. We look forward to sharing some best practices to optimize your spending and reduce your overall outlay.`
            },
            quartile: calculateQuartile(costQuestions),
            path: '/cost'
        },
    ]


  let doc = new jsPDF({
    orientation: "portrait",
    unit: "px",
    format: [PDF_WIDTH, PDF_HEIGHT],
  });

  const initiatePDF = () => {
    doc = new jsPDF({
      orientation: "portrait",
      unit: "px",
      format: [PDF_WIDTH, PDF_HEIGHT],
    });

    //set font
    doc.setFontSize(FONT_SIZE);
    doc.setFont("helvetica");
    doc.setTextColor("#26588C");
  };

  const handlePDFCreation = () => {
    //start it up
    initiatePDF();

    let currentY = 0;

    doc.setFillColor(FILL_COLOR);
    doc.rect(0, currentY, PDF_WIDTH, 53, "FD");
    //make header image
    doc.addImage("images/emerson-pdf-logo.png", "PNG", PDF_WIDTH - 121, 10, 82, 35);
    //Title
    doc.setTextColor("#FFFFFF");
    doc.setFont("helvetica", "normal");
    doc.setFontSize("22");
    doc.text("Onshore Wellpad Optimization Tool", LEFT_MARGIN, 36);

    currentY = INITIAL_Y + 5;
    doc.setTextColor("#000000");
    doc.text("Optimization Opportunity Results", LEFT_MARGIN, currentY);
    currentY += 20;
    doc.setFontSize("16");
    doc.text("Results below are based on your answers in the completed sections.", LEFT_MARGIN, currentY);
    currentY += 30;

    const charts = {
      "1st": chart1,
      "2nd": chart2,
      "3rd": chart3,
      "4th": chart4,
    };

    let currentX = LEFT_MARGIN;
    //Top Left Graph
    sections.map((section, index) => {
      let sectionY = currentY;
      let titleMargin = 60;

      if (section.quartile !== "incomplete") {
        doc.addImage(section.icon, "JPEG", currentX, sectionY, 50, 50);
        sectionY += 11;
        doc.setFontSize("22");
        doc.text(section.title, currentX + titleMargin, sectionY);
        doc.setFontSize("13");
        sectionY += 15;
        doc.text(`You rank in the ${section.quartile} quartile:`, currentX + titleMargin, sectionY);
        sectionY += 30;
        doc.addImage(charts[section.quartile], "JPEG", currentX, sectionY, 300, 100);
        sectionY += 110;
        //text box
        doc.setFillColor("#F0F0F0");
        doc.rect(currentX, sectionY, 300, 150, "F");
        let quartileString = section.statements[section.quartile];
        doc.setFontSize("16");
        doc.text(quartileString, currentX + 10, sectionY + 30, { maxWidth: 280, align: "left" });

        if (currentX == LEFT_MARGIN) {
          currentX += 400;
        } else {
          currentX = LEFT_MARGIN;
          currentY += 380;
        }
      } else {
        // doc.addImage(section.icon, "JPEG", currentX, sectionY, 50, 50);
        // sectionY += 11;
        // doc.setFontSize('22');
        // doc.text(section.title, currentX + titleMargin, sectionY);
        // doc.setFontSize('13');
        // sectionY += 15;
        // doc.text(`You rank in the ${section.quartile} quartile:`, currentX + titleMargin, sectionY);
        // sectionY += 30;
        // doc.addImage(chart4, "JPEG", currentX, sectionY, 300, 100);
        // sectionY += 110;
        // //text box
        // doc.setFillColor('#F0F0F0');
        // doc.rect(currentX, sectionY, 300, 150, 'F');
        // let quartileString = section.statements['4th'];
        // doc.setFontSize('16');
        // doc.text(quartileString, currentX + 10, sectionY + 30, {maxWidth: 280, align: 'left'});
      }

      // if (currentX == LEFT_MARGIN) {
      //     currentX += 400;
      // } else {
      //     currentX = LEFT_MARGIN;
      //     currentY += 380;
      // }
    });

    //save it!
    doc.save("emerson-form.pdf");
  };

  return (
    <Container maxWidth='lg' className='results_content'>
      <div>
        <Grid container justifyContent='center' rowSpacing={2} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
          <Grid className='results_heading' item xs={12} sm={8}>
            <h1>Optimization Opportunity Results</h1>
            <p>Results below are based on your answers in the completed sections. To save your results or contact an Emerson representative click “send results” or scroll to the bottom of the page.</p>
          </Grid>
          <Grid item xs={12} sm={4} justifyContent='flex-end'>
            <Button component={"a"} href='#contact' className='next_button result_button'>
             <span>Send Results</span><ArrowForwardIos />
            </Button>
          </Grid>
        </Grid>
      </div>

      <div className='results_container'>
        <Grid container justifyContent='center' rowSpacing={2} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
          {sections.map((section, index) =>
            section.quartile === "incomplete" ? (
              <Grid className='singleResultWrapper' item xs={12} sm={6}>
                <Oops className='singleResultWrapper' key={index} section={section} />
              </Grid>
            ) : (
              <Grid className='singleResultWrapper' item xs={12} sm={6}>
                <Result key={index} section={section} />
              </Grid>
            )
          )}
        </Grid>
      </div>

      <div id='contact' className='contact_container'>
        <div className='save_results'>
          <h2>Generate a PDF and save your results.</h2>
          <div className='contact_info'>
           


            <Grid item xs={0} sm={8} md={9}></Grid>
            <Grid item xs={12} sm={4} md={3}>
              <Button className='next_button save_button' onClick={handlePDFCreation}>
                <span>Save Results</span>
                <ArrowForwardIos />
              </Button>
            </Grid>
          </div>
        </div>


        <div className='talk_to_Roxar'>
          <Grid item xs={12}>
            <h2>Talk with a Roxar expert</h2>
            <p>Interested in learning more about how Roxar 2600 Multiphase Flow Meter (MPFM) could improve your operations? Contact an Emerson team expert today to schedule a conversation.</p>
          </Grid>


          <div className='contact_info'>
            <Grid container justifyContent='center' rowSpacing={2} columnSpacing={2}>
              <Grid item xs={12} sm={6}>
                <TextField className='text_field' variant='outlined' label='Name' onChange={ e => handleNameChange(e) } />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField className='text_field' variant='outlined' label='Company Name' onChange={ e => handleCompanyChange(e) } />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField className='text_field' variant='outlined' label='Phone' onChange={ e => handlePhoneChange(e) } />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField className='text_field' variant='outlined' label='Email' onChange={ e => handleEmailChange(e) } />
              </Grid>

              <Grid item xs={0} sm={8} md={9}></Grid>
              <Grid item xs={12} sm={4} md={3}>
                 <Button component='a' href={`mailto:info@roxar.com?subject=${name} with ${companyName} wants to learn more about ROXAR wellpad optimization &body=${emailBody}`} className='next_button save_button'><span>Email Expert</span><ArrowForwardIos /></Button>
              </Grid>
            </Grid>
          </div>
        </div>
      </div>
    </Container>
  );
            }


export default Results;
